import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { SiteHeader } from './SiteHeader';
import { SiteFooter } from './SiteFooter';
export function SiteLayout() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return <div className="flex min-h-screen w-full flex-col bg-white" data-id="element-151" data-mp="39ur5y7di07s8">
      <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-50 focus:rounded focus:bg-navy focus:px-4 focus:py-2 focus:text-white" data-id="element-152" data-mp="3dw2q3xdls0t1">
        Skip to content
      </a>
      <SiteHeader data-id="element-153" data-mp="3nlm8z31bfunw" />
      <main id="main" className="flex-1" data-id="element-154" data-mp="3nn76n1ixftpz">
        <Outlet data-id="element-155" data-mp="3skz5yglwii47" />
      </main>
      <SiteFooter data-id="element-156" data-mp="3sl8lfa9bl6vn" />
    </div>;
}